import { Alert, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BackButton from '@/components/ui/BackButton/BackButton.tsx';
import useReservationCancel from '@/api/useReservationCancel.ts';
import LoadingButton from '@/components/ui/LoadingButton/LoadingButton.tsx';
import CloseIcon from '@mui/icons-material/Close';

type CancelReservationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  reservationId: number;
};

function CancelReservationModal({ isOpen, onClose, reservationId }: CancelReservationModalProps) {
  const { t } = useTranslation();
  const {
    mutateAsync: cancelReservation,
    isPending: isLoadingCancelReservation,
    isError: isErrorCancelReservation,
    error: errorCancelReservation,
  } = useReservationCancel();

  const handleCancelReservation = () => {
    void (async () => {
      try {
        if (isLoadingCancelReservation || !reservationId) return;

        await cancelReservation({
          reservationId,
        });

        onClose();
      } catch (error) {
        console.error(error);
      }
    })();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm">
      <DialogTitle>{t('modals.cancelReservationModal.title')}</DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2 empty:hidden mb-2">
            {isErrorCancelReservation && <Alert severity="error">{errorCancelReservation?.message}</Alert>}
          </div>
          <div>{t('modals.cancelReservationModal.message')}</div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex flex-wrap grow p-4 pt-0 justify-between">
          <BackButton onClick={onClose} autoFocus />
          <LoadingButton
            loading={isLoadingCancelReservation}
            startIcon={<CloseIcon />}
            variant="contained"
            color="error"
            onClick={handleCancelReservation}
          >
            {t('button.cancelReservation')}
          </LoadingButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default CancelReservationModal;
